import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Toast, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
	IoIosClose,
	IoMdDownload,
	IoMdDoneAll,
	IoMdCreate,
	IoMdCalendar,
	IoMdTrash,
} from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const ProductTransferAddEdit = (props) => {
	let fileName = "";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const productTransfer = JSON.parse(localStorage.getItem("productTransfer"));
	fileName = `${outbounddata.VendorName} Product Transfer`;

	const userData = localStorage.getItem("userData");
	const history = useHistory();
	const [sales, setSales] = useState([]);
	const [gridData, setGridData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const [showCOnfirm, setShowConfirm] = useState(false);
	const [addshowConfirm, setaddShowConfirm] = useState(false);
	const [gridShow, setGridShow] = useState(false);
	const [product, setProduct] = useState({});
	const [editOrSaveInd, setEditOrSaveInd] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);
	const [addDisableSubmit, setAddSubmitDisable] = useState(false);
	const [showToaster, setShowToaster] = useState(false);
	const [disableSaveAll, setDisableSaveAll] = useState(false);
	const [isInvalidEmail, setEmailInValidity] = useState(false);
	const initialvalues = {
		BillTo: "",
		BillToID: "",
		BillingTOAddress: "",
		BillingTOState: "",
		BillingTOcity: "",
		BillingToZipCode: "",
		ContractReference: "",
		CustAddress: "",
		CustCity: "",
		CustID: "",
		CustName: "",
		CustPHSID: "",
		CustState: "",
		CustZip: "",
		CustomersInvoice: "",
		CustomersInvoiceDate: "",
		DosagORUnitstabs30: "",
		EffectiveDateRange: "",
		EmailID: "",
		FileProcessID: "",
		InvoiceNumber: "",
		ManufacturerPartNumber: "",
		ProductDescription: "",
		ProductNDC: "",
		PromotionNumber: "",
		PurchaseOrderNumber: "",
		RebateNumber: "",
		ReportENdTime: "",
		ReportStartTime: "",
		ReturnsQuantity: "",
		SKU: "",
		SaleQTY: "",
		ShipFrom: "",
		ShipFromID: "",
		ShipTOAddress: "",
		ShipTOState: "",
		ShipTOZipCode: "",
		ShipTOcity: "",
		ShipTo: "",
		ShipToID: "",
		ShipfromZipCode: "",
		ShippedDate: "",
		TotalLineCount: "",
		UPC: "",
		VendorPartNumber: "",
		shipfromaddress: "",
		shipfromcity: "",
		shipfromsate: "",
		LotNumber: "",
		UnitPriceCode: "",
		Unitofmeasure: "",
	};
	const [newSales, setNewSales] = useState(initialvalues);
	const [editIndex, setEditIndex] = useState();

	const Gridcolumns = [
		{
			Header: "Actions",
			accessor: "accessor",
			disableFilters: true,
			disableSortBy: true,
			width: 130,
			Cell: (row) => (
				<Fragment>
					<Button
						variant="link"
						onClick={() => editReport(row)}
						className="grid-action-btn ml-2"
						title="Edit Row"
					>
						<IoMdCreate className="icon" />
					</Button>
					<Button
						variant="link"
						onClick={() => deleteRecord(row)}
						className="grid-action-btn ml-2"
						title="Delete Row"
					>
						<IoMdTrash className="icon fa-icon" />
					</Button>
				</Fragment>
			),
		},
		{
			Header: "Account ID",
			accessor: "CustID",
			filter: "CustID",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Cust PHS ID",
			accessor: "CustPHSID",
			filter: "CustPHSID",
			key: true,
			sortType: "basic",
		},
		{
			Header: "Org Name",
			accessor: "CustName",
			filter: "CustName",
			key: true,
			sortType: "basic",
			width: 220,
		},
		{
			Header: "Account Address 1",
			accessor: "CustAddress",
			filter: "CustAddress",
			key: true,
			sortType: "basic",
			width: 220,
		},
		{
			Header: "Account City",
			accessor: "CustCity",
			filter: "CustCity",
			key: true,
			sortType: "basic",
			width: 110,
		},
		{
			Header: "Account State",
			accessor: "CustState",
			filter: "CustState",
			key: true,
			sortType: "basic",
			width: 110,
		},
		{
			Header: "Account Zip",
			accessor: "CustZip",
			filter: "CustZip",
			key: true,
			sortType: "basic",
			width: 110,
		},
		{
			Header: "INVOICE #",
			accessor: "CustomersInvoice",
			filter: "CustomersInvoice",
			key: true,
			sortType: "basic",
			width: 200,
		},
		{
			Header: "Customer Invoice Date",
			accessor: "CustomersInvoiceDate",
			filter: "CustomersInvoiceDate",
			sortType: "basic",
			key: true,
			field: true,
			future: true,
			width: 180,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Contract Reference",
			accessor: "ContractReference",
			filter: "ContractReference",
			key: true,
			sortType: "basic",
			width: 110,
		},
		{
			Header: "Product NDC",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			key: true,
			sortType: "basic",
			width: 120,
		},
		{
			Header: "PRODUCT DESCRIPTION",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			key: true,
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Qty",
			accessor: "SaleQTY",
			filter: "SaleQTY",
			key: true,
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Dosag OR Units tabs30",
			accessor: "DosagORUnitstabs30",
			filter: "DosagORUnitstabs30",
			key: true,
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Report Start Time",
			accessor: "ReportStartTime",
			filter: "ReportStartTime",
			//   key: true,
			sortType: "basic",
			width: 180,
			disable: true,
		},
		{
			Header: "Report End Time",
			accessor: "ReportENdTime",
			filter: "ReportENdTime",
			//   key: true,
			sortType: "basic",
			width: 180,
			disable: true,
		},
		{
			Header: "Email ID",
			accessor: "EmailID",
			filter: "EmailID",
			key: true,
			sortType: "basic",
			width: 320,
		},
		// {
		//   Header: "Invoice Number",
		//   accessor: "InvoiceNumber",
		//   filter: "InvoiceNumber",
		//   key: true,
		//   sortType: "basic",
		//   width: 150,
		// },
		{
			Header: "Purchase Order Number",
			accessor: "PurchaseOrderNumber",
			filter: "PurchaseOrderNumber",
			key: true,
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Ship To",
			accessor: "ShipTo",
			filter: "ShipTo",
			sortType: "basic",
			key: true,
			width: 320,
		},
		{
			Header: "Ship To ID",
			accessor: "ShipToID",
			filter: "ShipToID",
			key: true,
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship From",
			accessor: "ShipFrom",
			filter: "ShipFrom",
			key: true,
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship From ID",
			accessor: "ShipFromID",
			filter: "ShipFromID",
			//   key: true,
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Bill To",
			accessor: "BillTo",
			filter: "BillTo",
			key: true,
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Bill To ID",
			accessor: "BillToID",
			filter: "BillToID",
			key: true,
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Returns Quantity",
			accessor: "ReturnsQuantity",
			filter: "ReturnsQuantity",
			key: true,
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Vendor Part Number",
			accessor: "VendorPartNumber",
			filter: "VendorPartNumber",
			key: true,
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Manufacturer Part Number",
			accessor: "ManufacturerPartNumber",
			filter: "ManufacturerPartNumber",
			key: true,
			sortType: "basic",
			width: 80,
		},
		{
			Header: "UPC",
			accessor: "UPC",
			filter: "UPC",
			key: true,
			sortType: "basic",
			width: 180,
		},
		{
			Header: "SKU",
			accessor: "SKU",
			filter: "SKU",
			key: true,
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Shipped Date",
			accessor: "ShippedDate",
			filter: "ShippedDate",
			key: true,
			field: true,
			sortType: "basic",
			width: 120,
			future: true,
		},
		{
			Header: "Promotion Number",
			accessor: "PromotionNumber",
			filter: "PromotionNumber",
			key: true,
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Rebate Number",
			accessor: "RebateNumber",
			filter: "RebateNumber",
			key: true,
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Effective Date Range",
			accessor: "EffectiveDateRange",
			filter: "EffectiveDateRange",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Ship To Address",
			accessor: "ShipTOAddress",
			filter: "ShipTOAddress",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Ship To city",
			accessor: "ShipTOcity",
			filter: "ShipTOcity",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Ship To State",
			accessor: "ShipTOState",
			filter: "ShipTOState",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Ship To ZipCode",
			accessor: "ShipTOZipCode",
			filter: "ShipTOZipCode",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Ship From Address",
			accessor: "shipfromaddress",
			filter: "shipfromaddress",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Ship From City",
			accessor: "shipfromcity",
			filter: "shipfromcity",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Ship From State",
			accessor: "shipfromsate",
			filter: "shipfromsate",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Ship From ZipCode",
			accessor: "ShipfromZipCode",
			filter: "ShipfromZipCode",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Billing To Address",
			accessor: "BillingTOAddress",
			filter: "BillingTOAddress",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Billing To City",
			accessor: "BillingTOcity",
			filter: "BillingTOcity",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Billing To State",
			accessor: "BillingTOState",
			filter: "BillingTOState",
			sortType: "basic",
			width: 320,
			key: true,
		},
		{
			Header: "Billing To ZipCode",
			accessor: "BillingToZipCode",
			filter: "BillingToZipCode",
			sortType: "basic",
			width: 80,
			key: true,
		},
		{
			Header: "Total Line Count",
			accessor: "TotalLineCount",
			filter: "TotalLineCount",
			//   key: true,
			sortType: "basic",
			width: 80,
			disable: true,
		},
		{
			Header: "Lot Number",
			accessor: "LotNumber",
			filter: "LotNumber",
			sortType: "basic",
			// width:320,
			// key: outbounddata.TaskTypeCode == "GenentechProductTransfer" ? false:true,
			// disable: outbounddata.TaskTypeCode == "GenentechProductTransfer" ? true:false
			key: true,
		},
		{
			Header: "Monetary Amount",
			accessor: "MonetaryAmount",
			filter: "MonetaryAmount",
			sortType: "basic",
			// key: true,
			disable: true,
			// width:320,
		},
		{
			Header: "Unit PriceCode",
			accessor: "UnitPriceCode",
			filter: "UnitPriceCode",
			sortType: "basic",
			// key: outbounddata.TaskTypeCode == "GenentechProductTransfer" ? false:true,
			// disable: outbounddata.TaskTypeCode == "GenentechProductTransfer" ? true:false
			// width:80,
			key: true,
		},
		{
			Header: "Unit of measure",
			accessor: "Unitofmeasure",
			filter: "Unitofmeasure",
			sortType: "basic",
			// key: outbounddata.TaskTypeCode == "GenentechProductTransfer" ? false:true,
			// disable: outbounddata.TaskTypeCode == "GenentechProductTransfer" ? true:false
			// width:80,
			key: true,
		},
	];

	useEffect(() => {
		setGridData(productTransfer);
	}, []);

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (
			name === "EffectiveDateRange" ||
			name === "ReturnsQuantity" ||
			name === "CustomersInvoice" ||
			name === "DosagORUnitstabs30" ||
			name === "SaleQTY" ||
			name === "ProductNDC" ||
			name === "InvoiceNumber" ||
			name === "CustID" ||
			name === "CustZip" ||
			name === "ShipToID" ||
			name === "ShipFromID" ||
			name === "BillTo" ||
			name === "BillToID" ||
			name === "ShipTOZipCode" ||
			name === "ShipfromZipCode" ||
			name === "BillingToZipCode"
		) {
			const re = /^[\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setProduct((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setProduct((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	const newhandleChange = (e) => {
		const { name, value } = e.target;
		if (
			name === "EffectiveDateRange" ||
			name === "ReturnsQuantity" ||
			name === "CustomersInvoice" ||
			name === "DosagORUnitstabs30" ||
			name === "SaleQTY" ||
			name === "ProductNDC" ||
			name === "InvoiceNumber" ||
			name === "CustID" ||
			name === "CustZip" ||
			name === "ShipToID" ||
			name === "ShipFromID" ||
			name === "BillTo" ||
			name === "BillToID" ||
			name === "ShipTOZipCode" ||
			name === "ShipfromZipCode" ||
			name === "BillingToZipCode"
		) {
			const re = /^[\d\.,-]+$/;
			if (value === "" || re.test(value)) {
				setNewSales((values) => ({
					...values,
					[name]: value.trim(),
				}));
			}
		} else {
			setNewSales((values) => ({
				...values,
				[name]: value.replace(/\s{2,}/g, " "),
			}));
		}
	};

	function deleteRecord(row) {
		console.log(row.row.original);
		let data = gridData.filter((element, index) => {
			return index !== row.row.index;
		});
		const deletedData = Object.assign([], data);
		setGridData(deletedData);
	}

	useEffect(() => {
		setSubmitDisable(validateForm());
	}, [newSales]);
	useEffect(() => {
		setAddSubmitDisable(validateEditForm());
	}, [product]);

	const validateEditForm = () => {
		product.LotNumber = product.LotNumber ? product.LotNumber : "";
		product.Unitofmeasure = product.Unitofmeasure ? product.Unitofmeasure : "";
		product.UnitPriceCode = product.UnitPriceCode ? product.UnitPriceCode : "";
		if (
			product.CustID &&
			product.CustID.toString().trim() !== "" &&
			product.CustName &&
			product.CustName.toString().trim() !== "" &&
			product.CustPHSID &&
			product.CustPHSID.toString().trim() !== "" &&
			product.CustomersInvoice &&
			product.CustomersInvoice.toString().trim() !== "" &&
			(product.DosagORUnitstabs30 || product.DosagORUnitstabs30 === 0) &&
			product.DosagORUnitstabs30.toString().trim() !== "" &&
			product.EmailID &&
			product.EmailID.toString().trim() !== "" &&
			product.ManufacturerPartNumber &&
			product.ManufacturerPartNumber.toString().trim() !== "" &&
			product.ProductDescription &&
			product.ProductDescription.toString().trim() !== "" &&
			product.ProductNDC &&
			product.ProductNDC.toString().trim() !== "" &&
			product.PromotionNumber &&
			product.PromotionNumber.toString().trim() !== "" &&
			product.PurchaseOrderNumber &&
			product.PurchaseOrderNumber.toString().trim() !== "" &&
			product.PurchaseOrderNumber &&
			product.PurchaseOrderNumber.toString().trim() !== "" &&
			(product.RebateNumber || product.RebateNumber === 0) &&
			product.RebateNumber.toString().trim() !== "" &&
			(product.ReturnsQuantity || product.ReturnsQuantity === 0) &&
			product.ReturnsQuantity.toString().trim() !== "" &&
			product.SKU &&
			product.SKU.toString().trim() !== "" &&
			(product.SaleQTY || product.SaleQTY === 0) &&
			product.SaleQTY.toString().trim() !== "" &&
			product.ShipFrom &&
			product.ShipFrom.toString().trim() !== "" &&
			product.ShipTo &&
			product.ShipTo.toString().trim() !== "" &&
			product.ShipToID &&
			product.ShipToID.toString().trim() !== "" &&
			product.UPC &&
			product.UPC.toString().trim() !== "" &&
			product.VendorPartNumber &&
			product.BillTo &&
			product.BillTo.toString().trim() !== "" &&
			product.BillToID &&
			product.BillToID.toString().trim() !== "" &&
			product.CustAddress &&
			product.CustAddress.toString().trim() !== "" &&
			product.CustCity &&
			product.CustCity.toString().trim() !== "" &&
			product.CustState &&
			product.CustState.toString().trim() !== "" &&
			product.CustZip &&
			product.CustZip.toString().trim() !== "" &&
			product.ShipTOAddress &&
			product.ShipTOAddress.toString().trim() !== "" &&
			product.ShipTOcity &&
			product.ShipTOcity.toString().trim() !== "" &&
			product.ShipTOState &&
			product.ShipTOState.toString().trim() !== "" &&
			product.ShipTOZipCode &&
			product.ShipTOZipCode.toString().trim() !== "" &&
			product.shipfromaddress &&
			product.shipfromaddress.toString().trim() !== "" &&
			product.shipfromcity &&
			product.shipfromcity.toString().trim() !== "" &&
			product.shipfromsate &&
			product.shipfromsate.toString().trim() !== "" &&
			product.ShipfromZipCode &&
			product.ShipfromZipCode.toString().trim() !== "" &&
			product.BillingTOAddress &&
			product.BillingTOAddress.toString().trim() !== "" &&
			product.BillingTOcity &&
			product.BillingTOcity.toString().trim() !== "" &&
			product.BillingTOState &&
			product.BillingTOState.toString().trim() !== "" &&
			product.BillingToZipCode &&
			product.BillingToZipCode.toString().trim() !== "" &&
			product.BillingTOAddress &&
			product.BillingTOAddress.toString().trim() !== "" &&
			product.BillingTOcity &&
			product.BillingTOcity.toString().trim() !== "" &&
			product.LotNumber &&
			product.LotNumber.toString().trim() !== "" &&
			product.UnitPriceCode &&
			product.UnitPriceCode.toString().trim() !== "" &&
			product.Unitofmeasure &&
			product.Unitofmeasure.toString().trim() !== ""
		) {
			let tempMail = product.EmailID;
			const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (emailFormat.test(tempMail)) {
				setEmailInValidity(false);
				return false;
			} else {
				setEmailInValidity(true);
				return true;
			}
		} else {
			setEmailInValidity(false);
			return true;
		}
	};
	const validateForm = () => {
		if (
			newSales.CustID &&
			newSales.CustID.toString().trim() !== "" &&
			newSales.CustName &&
			newSales.CustName.toString().trim() !== "" &&
			newSales.CustPHSID &&
			newSales.CustPHSID.toString().trim() !== "" &&
			newSales.CustomersInvoice &&
			newSales.CustomersInvoice.toString().trim() !== "" &&
			(newSales.DosagORUnitstabs30 || newSales.DosagORUnitstabs30 === 0) &&
			newSales.DosagORUnitstabs30.toString().trim() !== "" &&
			newSales.EmailID &&
			newSales.EmailID.toString().trim() !== "" &&
			newSales.ManufacturerPartNumber &&
			newSales.ManufacturerPartNumber.toString().trim() !== "" &&
			newSales.ProductDescription &&
			newSales.ProductDescription.toString().trim() !== "" &&
			newSales.ProductNDC &&
			newSales.ProductNDC.toString().trim() !== "" &&
			newSales.PromotionNumber &&
			newSales.PromotionNumber.toString().trim() !== "" &&
			newSales.PurchaseOrderNumber &&
			newSales.PurchaseOrderNumber.toString().trim() !== "" &&
			newSales.PurchaseOrderNumber &&
			newSales.PurchaseOrderNumber.toString().trim() !== "" &&
			(newSales.RebateNumber || newSales.RebateNumber === 0) &&
			newSales.RebateNumber.toString().trim() !== "" &&
			(newSales.ReturnsQuantity || newSales.ReturnsQuantity === 0) &&
			newSales.ReturnsQuantity.toString().trim() !== "" &&
			newSales.SKU &&
			newSales.SKU.toString().trim() !== "" &&
			(newSales.SaleQTY || newSales.SaleQTY === 0) &&
			newSales.SaleQTY.toString().trim() !== "" &&
			newSales.ShipFrom &&
			newSales.ShipFrom.toString().trim() !== "" &&
			newSales.ShipTo &&
			newSales.ShipTo.toString().trim() !== "" &&
			newSales.ShipToID &&
			newSales.ShipToID.toString().trim() !== "" &&
			newSales.UPC &&
			newSales.UPC.toString().trim() !== "" &&
			newSales.VendorPartNumber &&
			newSales.BillTo &&
			newSales.BillTo.toString().trim() !== "" &&
			newSales.BillToID &&
			newSales.BillToID.toString().trim() !== "" &&
			newSales.CustAddress &&
			newSales.CustAddress.toString().trim() !== "" &&
			newSales.CustCity &&
			newSales.CustCity.toString().trim() !== "" &&
			newSales.CustState &&
			newSales.CustState.toString().trim() !== "" &&
			newSales.CustZip &&
			newSales.CustZip.toString().trim() !== "" &&
			newSales.ShipTOAddress &&
			newSales.ShipTOAddress.toString().trim() !== "" &&
			newSales.ShipTOcity &&
			newSales.ShipTOcity.toString().trim() !== "" &&
			newSales.ShipTOState &&
			newSales.ShipTOState.toString().trim() !== "" &&
			newSales.ShipTOZipCode &&
			newSales.ShipTOZipCode.toString().trim() !== "" &&
			newSales.shipfromaddress &&
			newSales.shipfromaddress.toString().trim() !== "" &&
			newSales.shipfromcity &&
			newSales.shipfromcity.toString().trim() !== "" &&
			newSales.shipfromsate &&
			newSales.shipfromsate.toString().trim() !== "" &&
			newSales.ShipfromZipCode &&
			newSales.ShipfromZipCode.toString().trim() !== "" &&
			newSales.BillingTOAddress &&
			newSales.BillingTOAddress.toString().trim() !== "" &&
			newSales.BillingTOcity &&
			newSales.BillingTOcity.toString().trim() !== "" &&
			newSales.BillingTOState &&
			newSales.BillingTOState.toString().trim() !== "" &&
			newSales.BillingToZipCode &&
			newSales.BillingToZipCode.toString().trim() !== "" &&
			newSales.BillingTOAddress &&
			newSales.BillingTOAddress.toString().trim() !== "" &&
			newSales.BillingTOcity &&
			newSales.BillingTOcity.toString().trim() !== "" &&
			newSales.LotNumber &&
			newSales.LotNumber.toString().trim() !== "" &&
			newSales.UnitPriceCode &&
			newSales.UnitPriceCode.toString().trim() !== "" &&
			newSales.Unitofmeasure &&
			newSales.Unitofmeasure.toString().trim() !== ""
		) {
			let tempMail = newSales.EmailID;
			const emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (emailFormat.test(tempMail)) {
				setEmailInValidity(false);
				return false;
			} else {
				setEmailInValidity(true);
				return true;
			}
		} else {
			setEmailInValidity(false);
			return true;
		}
	};

	function saveRowHandler() {
		if (!editOrSaveInd) {
			newSales.ReportStartTime = productTransfer[0].ReportStartTime;
			newSales.ReportENdTime = productTransfer[0].ReportENdTime;
			newSales.ShippedDate = moment(
				product.ShippedDate ? product.ShippedDate : new Date()
			).format("MM/DD/YYYY");
			newSales.CustomersInvoiceDate = moment(
				product.CustomersInvoiceDate ? product.CustomersInvoiceDate : new Date()
			).format("MM/DD/YYYY");
			newSales.ind = Object.assign({}, gridData.length + 1);
			newSales.ind = gridData.length + 1;
			const ns = Object.assign({}, newSales);
			gridData.unshift(ns);
			setaddShowConfirm(false);
			setNewSales(initialvalues);
			newSales.ind = 0;
		}
	}

	function editRowHandler() {
		let indicator = 0;
		product.ShippedDate = moment(product.ShippedDate).format("MM/DD/YYYY");
		product.CustomersInvoiceDate = moment(product.CustomersInvoiceDate).format(
			"MM/DD/YYYY"
		);
		if (product.CustID && product.CustID) {
			if (editOrSaveInd) {
				gridData.filter((element, index) => {
					if (editIndex === index) {
						const productTransferTemp = Object.assign({}, product);
						gridData[index] = productTransferTemp;
					}
				});
			}
			indicator = 1;
		}

		if (indicator !== 0) {
			console.log(product);
			setShowConfirm(false);
			setEmailInValidity(false);
		}
	}

	const editReport = (productTransfers) => {
		setEditIndex(productTransfers.row.index);
		setProduct(
			{
				...product,
				...productTransfers.row.original,
			},
			setAddSubmitDisable(validateEditForm())
		);
		setShowConfirm(true);
		setEditOrSaveInd(true);
		setAddSubmitDisable(validateEditForm());
		setEmailInValidity(false);
	};

	const EditRecords = () => {
		setGridShow(true);
	};

	const saveRecords = () => {
		setaddShowConfirm(true);
		setEditOrSaveInd(false);
	};

	const saveallRecords = () => {
		setDisableSaveAll(true);
		gridData.map((element) => {
			element.FileProcessID = productTransfer[0].FileProcessID;
			element.ModifiedOn = new Date();
			element.LastModifiedBy = JSON.parse(userData).UserName;
			element.IsResendRequired =
				outbounddata.FileSentStatus === "Sent" ? true : false;
			element.IsReadyforReversal = true;
			element.IsEdited = true;
			element.Version = 1;
			element.Service_Task_Id = outbounddata.ServiceTaskID;
		});

		setLoading(true);
		_HttpServices
			.postData("Api/Edi844/ReversalOutbound867", gridData)
			.then((data) => {
				if (data.data === "") {
					setShowToaster(true);
					setTimeout(() => history.push("/outbound-reports"), 1000);
					setLoading(false);
				}
			})
			.catch((e) => {
				setLoading(false);
				setDisableSaveAll(false);
			});
	};

	const closeAddModal = () => {
		setaddShowConfirm(false);
		setEmailInValidity(false);
	};

	const closeEditModal = () => {
		setShowConfirm(false);
		setEmailInValidity(false);
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<Toast
					onClose={() => setShowToaster(false)}
					show={showToaster}
					delay={1500}
					autohide
					className="custom-toaster"
				>
					<Toast.Body>Details updated successfully</Toast.Body>
				</Toast>
				<div>
					{!gridShow && (
						<Button
							variant="primary"
							type="button"
							onClick={() => saveRecords()}
						>
							Add Record
						</Button>
					)}
					<Button
						className="ml-2"
						type="submit"
						onClick={() => getExcel(Gridcolumns, gridData, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>

				{/* Add New Record Modal */}
				<Modal
					show={addshowConfirm}
					onHide={() => closeAddModal()}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>Add Record</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											<Row>
												{Gridcolumns.map(function (i, index) {
													return (
														i.accessor !== "accessor" && (
															<Col md={3} key={index}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{i.accessor !== "accessor"
																				? i.Header
																				: ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={newSales[i.accessor]}
																				selected={
																					newSales[i.accessor]
																						? new Date(
																								moment(
																									newSales[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setNewSales((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={i.future ? new Date() : null}
																			/>
																		)}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={newSales[i.accessor]}
																				key={product[i.accessor]}
																				onChange={(e) => newhandleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																		{i.accessor === "EmailID" &&
																			isInvalidEmail &&
																			isInvalidEmail === true && (
																				<span style={{ color: "red" }}>
																					Please enter valid email
																				</span>
																			)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								type="submit"
								disabled={disableSubmit}
								onClick={() => saveRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Save
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => closeAddModal()}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>

				{/* Edit Existing Record MOdal */}
				<Modal
					show={showCOnfirm}
					onHide={() => closeEditModal()}
					backdrop="static"
					keyboard={false}
					size="lg"
				>
					<Modal.Header closeButton>
						<Modal.Title>Edit Record</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col md={12}>
								<div className="card pt-2 mb-4">
									<div className="card-body">
										<Form>
											<Row>
												{Gridcolumns.map(function (i, index) {
													return (
														i.accessor !== "accessor" && (
															<Col md={3} key={index}>
																<Form.Group>
																	<div className="date-picker ungroup-date-picker pos-rl">
																		<Form.Label htmlFor="StartDate">
																			{i.accessor !== "accessor"
																				? i.Header
																				: ""}
																			{i.key && (
																				<span className="err-msg">*</span>
																			)}
																		</Form.Label>
																		{i.field && (
																			<IoMdCalendar className="icon date-icon" />
																		)}
																		{i.field && (
																			<DatePicker
																				key={product[i.accessor]}
																				selected={
																					i.field
																						? new Date(
																								moment(
																									product[i.accessor]
																								).format("MM/DD/YYYY")
																						  )
																						: new Date()
																				}
																				onChange={(e) =>
																					setProduct((values) => ({
																						...values,
																						[i.accessor]: e,
																					}))
																				}
																				maxDate={i.future ? new Date() : null}
																			/>
																		)}
																		{!i.field && (
																			<Form.Control
																				required
																				type="text"
																				name={i.accessor}
																				value={product[i.accessor]}
																				// key={cont[i.accessor]}
																				onChange={(e) => handleChange(e)}
																				disabled={i.disable}
																			/>
																		)}
																		{i.accessor === "EmailID" &&
																			isInvalidEmail && (
																				<span
																					style={{ color: "red", fontSize: 11 }}
																				>
																					Please enter valid email
																				</span>
																			)}
																	</div>
																</Form.Group>
															</Col>
														)
													);
												})}
											</Row>
										</Form>
									</div>
								</div>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div className="text-right mt-2">
							<Button
								disabled={addDisableSubmit}
								onClick={() => editRowHandler()}
							>
								<IoMdDoneAll className="icon btn-icon" />
								Edit Row
							</Button>
							<Button
								variant="danger"
								className="ml-3 btn-sm"
								onClick={() => closeEditModal()}
							>
								<IoIosClose className="icon btn-icon" />
								Cancel
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</div>

			{gridShow && (
				<Row>
					<Col md={12}>
						<div className="card pt-2">
							<div className="card-body">
								<div className="inventory-grid">
									{hasError ? (
										<p>Error occurred. Unable to load {fileName}</p>
									) : (
										<Fragment>
											{sales.length > 0 ? (
												<ReactTable
													columns={Gridcolumns}
													data={sales}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</Fragment>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			)}
			{!gridShow && (
				<Row>
					<Col md={12}>
						<span className="mb-4 h6">
							File Name: {outbounddata.File_Process_Name}
						</span>{" "}
						<span className="ml-4 h6">Version: {outbounddata.Fileversion}</span>
						<div className="card pt-2">
							<div className="card-body">
								<div className="inventory-grid">
									{hasError ? (
										<p>Error occurred. Unable to load {fileName}</p>
									) : (
										<Fragment>
											{gridData.length > 0 ? (
												<ReactTable
													columns={Gridcolumns}
													data={gridData}
													defaultPageSize={10}
												/>
											) : (
												<div className="no-data">No data found.</div>
											)}
										</Fragment>
									)}
								</div>
							</div>
						</div>
					</Col>
				</Row>
			)}
			<Row>
				<Col md={12} className="text-right mt-2">
					{gridData.length > 0 && (
						<Button
							variant="primary"
							type="button"
							disabled={disableSaveAll}
							onClick={() => saveallRecords()}
						>
							Save Records
						</Button>
					)}
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default ProductTransferAddEdit;
